<yc-modal *ngIf="loaded"
  [modalHeader]="modalHeader"
  [modalSubHeader]="isAwardTypeView ?
    '' :
    (
      awardType === AwardTypes.DOLLARS ?
        ('GLOBAL:textCash' | ycI18n: 'Cash') :
        ('GLOBAL:hdrInKind' | ycI18n: 'In Kind')
    )">

  <!-- Award Type View -->
  <ng-container *ngIf="isAwardTypeView">
    <ng-container *ngIf="awardTypeFormGroup"
      [formGroup]="awardTypeFormGroup">
      <yc-typeahead-select
        name="awardType"
        [items]="awardTypeOptions"
        [label]="'AWARDS:textWhatTyepOfAwardIsThis' | ycI18n: 'What type of award is this?'"
        (onChange)="onAwardTypeChange()">
      </yc-typeahead-select>
    </ng-container>
  </ng-container>

  <!-- Award / Payment View -->
  <ng-container *ngIf="!isAwardTypeView">
    <!-- Conversion Message -->
    <div *ngIf="showConversions">
      <yc-alert
        alertClass="info"
        [message]="conversionMessage">
      </yc-alert>
    </div>

    <div class="mb-3">
      <gc-applicant-org-details-block
        [isMasked]="isMasked"
        [organization]="organization"
        [applicant]="applicant">
      </gc-applicant-org-details-block>
    </div>

    <!-- Award Form Group View -->
    <div *ngIf="awardFormGroup" 
      [formGroup]="awardFormGroup"
      class="d-flex">
      <!-- Request Amount -->
      <div class="flex-basis-25 me-3">
        <yc-input
          name="amountRequested"
          [label]="'GLOBAL:lblRequestAmount' | ycI18n:'Request amount'"
          [disabled]="true"
          [help]="amountRequestedHelpText">
        </yc-input>
      </div>

      
      <!-- Award Amount -->
      <div class="flex-basis-25 me-3">
        <gc-award-amount-control
          [controlName]="'awardAmount'"
          [awardFormGroup]="awardFormGroup | ycAs: $awardGroup"
          [disabled]="isUnits || !!originalPayment || addPaymentOnly"
          [currencyRequested]="currencyRequested"
          [recommendedText]="recommendedText"
          [rate]="rate"
          [showConversions]="showConversions"
          (onAmountChange)="awardAmountChange()">
        </gc-award-amount-control>
      </div>

      <!-- Payments for this Award -->
      <div class="flex-basis-25 me-3">
        <yc-input
          name="scheduledPayments"
          [label]="'AWARDS:lblPaymentsForThisAward' | ycI18n: 'Payments for this award'"
          [disabled]="true"
          [help]="scheduledHelpText">
        </yc-input>
      </div>

      <!-- Award Balance -->
      <div class="flex-basis-25">
        <yc-input
          name="awardBalance"
          [label]="'GLOBAL:lblAwardBalance' | ycI18n:'Award balance'"
          [disabled]="true"
          [danger]="negativeBalance"
          [help]="awardBalanceHelpText">
        </yc-input>
      </div>
    </div>

    <!-- In Kind Items Selector -->
    <div *ngIf="isUnits && itemsToAward && awardFormGroup"
      [formGroup]="unitsFormGroup">
      <div class="in-kind-help">
        <yc-i18n *ngIf="!onlyPaymentAddOrEdit"
          key="AWARDS:textInKindAwardHelpText"
          defaultValue="Below are the items being awarded. By default these items are those requested by the applicant. Requested items can be edited or additional items added. The award amount is the sum of the total value (requested units times value per unit) for all items.">
        </yc-i18n>
        <yc-i18n *ngIf="onlyPaymentAddOrEdit"
          key="AWARDS:textInKindAwardHelpText2"
          defaultValue="Below are the items being awarded.">
        </yc-i18n>
      </div>
      <yc-alert *ngIf="inactiveRequestedItems"
        alertClass="warning"
        [message]="('AWARDS:textRequestedItemsNoLongerActive' | ycI18n: 'Requested items no longer active') + ': ' + inactiveRequestedItems">
      </yc-alert>
      <div class="mb-5">
        <gc-in-kind-items-selector-table
          [disabled]="!!onlyPaymentAddOrEdit"
          [isAward]="true"
          [inKindItems]="itemsToAward"
          [paidItems]="itemsToPay"
          [alreadyAwardedItems]="alreadyAwardedItems"
          [alreadyPaidItems]="alreadyPaidItems"
          [totalText]="'GLOBAL:textAwardAmount' | ycI18n: 'Award amount'"
          (onEditChange)="editingAwardItems = $event"
          (onItemsChange)="onItemsChange($event, true)"
          (onTotalChange)="onTotalItemsChange($event, true)">
        </gc-in-kind-items-selector-table>
      </div>
    </div>

    <!-- Payment Form Group View -->
    <div *ngIf="paymentFormGroup"
      [formGroup]="paymentFormGroup"
      class="mt-3">
      <yc-horizontal-nav-tabs
        [tabs]="paymentTabs"
        [useRoutes]="false"
        [fullWidth]="true"
        (activeTabChanged)="$event === 0 ?
          isPaymentView = true :
          isPaymentView = false">
      </yc-horizontal-nav-tabs>
      <div class="yc-layout-table">
        <!-- Payment View -->
        <div [ycHidden]="!isPaymentView">

          <ng-container *ngIf="!!payment.id && isOriginalBudgetFsSelected">
            <!-- Budget Funding Source Closed Existing Payment Alert -->
            <yc-alert *ngIf="budgetFundingSource?.budget.isClosed &&
              !budgetFundingSource?.fundingSource.isFundingSourceClosed"
              alertClass="info"
              [message]="'AWARDS:textBudgetForPaymentClosed' | ycI18n: 'The budget for this payment has been closed and cannot be edited.'">
            </yc-alert>

            <yc-alert *ngIf="budgetFundingSource?.fundingSource.isFundingSourceClosed &&
              !budgetFundingSource?.budget.isClosed"
              alertClass="info"
              [message]="'AWARDS:textFundingSourceForPaymentClosed' | ycI18n: 'The funding source for this payment has been closed and cannot be edited.'">
            </yc-alert>

            <yc-alert *ngIf="budgetFundingSource?.budget.isClosed &&
              budgetFundingSource?.fundingSource.isFundingSourceClosed"
              alertClass="info"
              [message]="'AWARDS:textBudgetAndFundingSourceForPaymentClosed' | ycI18n: 'The budget and funding source for this payment have been closed and cannot be edited.'">
            </yc-alert>
          </ng-container>

          <!-- Payment Alert -->
          <div *ngIf="!originalPayment"
            class="mb-2">
            <yc-alert
              alertClass="info"
              [message]="createPaymentAlertHelper">
            </yc-alert>
          </div>

          <yc-alert *ngIf="complianceAlert"
            alertClass="warning"
            [message]="complianceAlert">
          </yc-alert>

          <!-- Budget / Funding Source Select -->
          <div class="ps-0 pe-0">
            <gc-budget-fs-typeahead
              [disabled]="budgetFsDisabled"
              [remainingAmountBudgetMap]="remainingAmountBudgetMap"
              [budgetFundingSourceOptions]="budgetFundingSourceOptions"
              [comboId]="payment.budget + '-' + payment.fundingSource"
              (onBudgetFsChange)="sourceChanged()">
            </gc-budget-fs-typeahead>
          </div>

          <!-- Payment Row -->
          <div class="d-flex align-items-center">
            <!-- Available to Process -->
            <div class="me-2"
              [class.flex-basis-50]="!showRemovePayment && !paymentDisplayInfo.showConversion"
              [class.flex-basis-49]="(showRemovePayment && !paymentDisplayInfo.showConversion)"
              [class.flex-basis-32]="showRemovePayment && paymentDisplayInfo.showConversion">
              <yc-datepicker
                name="date"
                [hideDateIcon]="true"
                [disabled]="!!payment.id && payment.statusId !== PaymentStatuses.Pending"
                [isLocked]="!!payment.id && payment.statusId !== PaymentStatuses.Pending"
                [label]="isUnits ?
                  ('GLOBAL:lblPaymentDate' | ycI18n: 'Payment date') :
                  ('GLOBAL:textAvailableToProcess' | ycI18n: 'Available to process')"
                (onChange)="paymentChanged()">
              </yc-datepicker>
            </div>

            <!-- Payment Amount -->
            <div [class.flex-basis-50]="!showRemovePayment && !paymentDisplayInfo.showConversion"
              [class.flex-basis-49]="(showRemovePayment && !paymentDisplayInfo.showConversion)"
              [class.flex-basis-32]="showRemovePayment && paymentDisplayInfo.showConversion">
              <yc-input
                name="amount"
                [currencyData]="formattingData[
                  paymentDisplayInfo.currencyKey
                ]"
                [isNumber]="true"
                [disabled]="isUnits | gcIsPaymentAmountDisabled:
                  !!payment.id:
                  payment.statusId:
                  paymentDisplayInfo.isEditing:
                  isUpdatingBudget:
                  budgetFundingSource?.isClosed"          
                [isLocked]="isUnits | gcIsPaymentAmountDisabled:
                  !!payment.id:
                  payment.statusId:
                  paymentDisplayInfo.isEditing:
                  isUpdatingBudget:
                  budgetFundingSource?.isClosed"
                [leftIcon]="paymentDisplayInfo.currencySymbol ? {
                  icon: paymentDisplayInfo.currencySymbol,
                  isStaticText: true
                } : null"
                [rightIcons]="rightIcons"
                [label]="paymentDisplayInfo.amountLabel"
                [help]="paymentDisplayInfo.amountHelp"
                (onChange)="paymentChanged(showConversions)">
              </yc-input>
            </div>

            <!-- Conversions -->
            <div *ngIf="paymentDisplayInfo.showConversion"
              class="ms-2 flex-basis-32">
              <yc-input
                name="conversion"
                [currencyData]="formattingData[defaultCurrency]"
                [isNumber]="true"
                [leftIcon]="{
                  icon: defaultSymbol,
                  isStaticText: true
                }"
                [disabled]="!paymentDisplayInfo.isEditing"
                [rightIcons]="paymentDisplayInfo.isEditing ?
                  paymentDisplayInfo.saveIcons :
                  paymentDisplayInfo.canEdit ?
                    paymentDisplayInfo.editIcons :
                    null"
                [label]="'GLOBAL:textCurrencyConversionDynamic' | ycI18n: '__currency__ conversion': { currency: defaultCurrency }">
              </yc-input>
            </div>

            <div *ngIf="showRemovePayment"
              class="ms-2 mt-3 flex-basis-2">
              <yc-button
                [icon]="true"
                [fontAwesomeIcon]="'times'"
                [textDanger]="true"
                [tooltipText]="'AWARDS:textRemovePayment' | ycI18n: 'Remove payment'"
                (onClick)="removePayment()">
              </yc-button>
            </div>
          </div>

          <div *ngIf="isUnits && itemsToPay &&
            (potentialItemsToPay.length > 0 || originalPayment)"
            class="mt-3">
            <gc-in-kind-items-selector-table
              [isAward]="false"
              [disabled]="!!payment.id && budgetFundingSource?.isClosed"
              [inKindItems]="itemsToPay"
              [awardedItems]="itemsToAward"
              [originalPayment]="originalPayment"
              [alreadyPaidItems]="alreadyPaidItems"
              [totalText]="'GLOBAL:hdrPaymentAmount' | ycI18n: 'Payment amount'"
              (onEditChange)="editingPaidItems = $event"
              (onItemsChange)="onItemsChange($event, false)"
              (onTotalChange)="onTotalItemsChange($event, false)">
            </gc-in-kind-items-selector-table>
          </div>
          <div *ngIf="!originalPayment &&
            (isUnits && itemsToPay && potentialItemsToPay.length === 0)"
            class="mt-3">
            <yc-i18n
              key="AWARDS:textNoItemsAvailableToSelectForAward"
              defaultValue="All available items from the award have been used. To add a new item, add it to the award first.">
            </yc-i18n>
          </div>
        </div>

        <!-- Additional Options View -->
        <div [ycHidden]="isPaymentView">
          <!-- Award Options -->
          <ng-container *ngIf="awardOnly ||
            (!originalPayment && !addPaymentOnly)">
            <ng-template *ngTemplateOutlet="awardOptions"></ng-template>
          </ng-container>

          <!-- Payment Options -->
          <ng-template *ngTemplateOutlet="paymentOptions"></ng-template>
        </div>
      </div>
    </div>

    <div *ngIf="!paymentFormGroup">
      <!-- Award Options -->
      <ng-template *ngTemplateOutlet="awardOptions"></ng-template>

      <!-- Add a Payment -->
      <div *ngIf="!awardOnly || !originalAward" 
        class="mt-3">
        <yc-button
          [link]="true"
          [langKey]="'AWARDS:textAddPayment'"
          [defaultText]="'Add payment'"
          (onClick)="addPayment()">
          <yc-fa icon="plus" class="me-2"></yc-fa>
        </yc-button>
      </div>
    </div>
  </ng-container>

  <!-- Modal Footer -->
  <div *ycModalFooter
    class="modal-footer">
    <div class="flex-grow-1 d-flex full-width justify-content-between">
      <div class="d-flex">
        <!-- Cancel left aligned -->
        <yc-button *ngIf="!isAwardTypeView"
          [link]="true"
          [langKey]="'common:btnCancel'"
          [defaultText]="'Cancel'"
          class="d-flex justify-content-start"
          (onClick)="closeModal.emit()">
        </yc-button>
      </div>
      <div class="d-flex align-items-center"
        [class.justify-content-between]="isAwardTypeView"
        [class.flex-grow-1]="isAwardTypeView">
        <!-- Standard Secondary Button -->
        <ng-container *ngIf="!isAwardTypeView &&
          budgetFundingSourceOptionsForNewPayment?.length > 0">
          <gc-create-payment-popover-button
            [buttonText]="'GLOBAL:textSaveAndAddNewPayment' | ycI18n: 'Save and add new payment'"
            [canMoveFundsText]="canMoveFundsText"
            [isYcProcessed]="isYcProcessed"
            class="me-3"
            [isEdit]="!!originalPayment"
            [isUpdatingBudget]="isUpdatingBudget"
            [isUpdatingBudgetFromClientToYc]="isUpdatingBudgetFromClientToYc"
            [isLink]="true"
            [disabled]="modalInvalid || cantAddNewPayment"
            [bypassAttestation]="bypassAttestation"
            (onSubmit)="onSecondaryClick()">
          </gc-create-payment-popover-button>
        </ng-container>

        <yc-button *ngIf="isAwardTypeView"
          class="me-2"
          [link]="true"
          [langKey]="'common:btnCancel'"
          [defaultText]="'Cancel'"
          (onClick)="onSecondaryClick()">
        </yc-button> 

        <!-- Next -->
        <yc-button *ngIf="isAwardTypeView"
          [primary]="true"
          [langKey]="'common:btnNext'"
          [defaultText]="'Next'"
          class="d-flex justify-content-end"
          (onClick)="onPrimaryClick()">
        </yc-button>
   
        <gc-create-payment-popover-button *ngIf="!isAwardTypeView"
          [buttonText]="'common:btnSave' | ycI18n: 'Save'"
          [canMoveFundsText]="canMoveFundsText"
          [isYcProcessed]="isYcProcessed"
          [isEdit]="!!originalPayment"
          [isUpdatingBudget]="isUpdatingBudget"
          [isUpdatingBudgetFromClientToYc]="isUpdatingBudgetFromClientToYc"
          [disabled]="modalInvalid || submitting"
          [bypassAttestation] = "bypassAttestation"
          class="d-flex justify-content-end"
          (onSubmit)="onPrimaryClick()">
        </gc-create-payment-popover-button>

      </div>
    </div>
  </div>
</yc-modal>

<!-- Award Options -->
<ng-template #awardOptions>
  <div *ngIf="awardFormGroup"
    [formGroup]="awardFormGroup">
    <div *ngIf="!awardOnly" 
      class="award-payment-header">
      <yc-i18n
        key="common:lblAward">
      </yc-i18n>
    </div>

    <div class="d-flex">
      <!-- Award Date -->
      <div class="flex-basis-50 me-3">
        <yc-datepicker
          name="awardDate"
          [label]="'AWARDS:textAwardDate' | ycI18n: 'Award date'"
          [help]="'AWARDS:textAwardDateHelp' | ycI18n: 'This date is used for reports. If this award needs to fall within a specific time period, enter an appropriate date here.'">
        </yc-datepicker>
      </div>
      
      <!-- Description -->
      <div class="flex-basis-50">
        <yc-input
          name="description"
          [label]="'common:textDescription' | ycI18n">
        </yc-input>
      </div>
    </div>

    <!-- Send Message -->
    <div *ngIf="!award && applicantCanReceiveEmails">
      <div class="row">
        <div class="col-md-12 mt-4">
          <yc-checkbox *ngIf="currentEmailActive"
            name="notifyApplicant"
            [optionLabel]="'AWARD:textNotifyApplicantsAwardDesc' | ycI18n: 'Send email to notify applicant(s) of award decision'">
          </yc-checkbox>

          <gc-email-disabled-alert *ngIf="!currentEmailActive"
            [currentEmailType]="currentEmailType">
          </gc-email-disabled-alert>
        </div>
      </div>

      <gc-select-email-template *ngIf="currentEmailActive"
        [emailType]="currentEmailType"
        [notifyApplicant]="awardFormGroup.value.notifyApplicant"
        [programId]="programId"
        [applicationIds]="[applicationId]"
        [formGroup]="awardFormGroup">
      </gc-select-email-template>
    </div>
  </div>
</ng-template>

<!-- Payment Options -->
<ng-template #paymentOptions>
  <div *ngIf="paymentFormGroup"
    [formGroup]="paymentFormGroup"
    class="mt-3">
    <div class="award-payment-header">
      <yc-i18n
        key="common:lblPayment">
      </yc-i18n>
    </div>
    <!-- Designation -->
    <div>
      <yc-input
        name="paymentDesignation"
        [label]="'GLOBAL:textDesignation' | ycI18n: 'Designation'"
        (onChange)="paymentChanged()">
      </yc-input>
    </div>

    <!-- Add Notes and Tags -->
    <div *ngIf="!showNotesAndTags"
      class="mt-3">
      <yc-button
        [link]="true"
        [value]="'AWARDS:textAddNotesAndTags' | ycI18n: 'Add notes and tags'"
        (onClick)="showNotesAndTags = true">
        <yc-fa icon="plus" class="me-2"></yc-fa>
        <yc-i18n
          key="AWARDS:textAddNotesAndTags"
          defaultValue="Add notes and tags">
        </yc-i18n>
      </yc-button>
    </div>
    <ng-container *ngIf="showNotesAndTags">
      <!-- Notes  -->
      <div class="mt-3">
        <yc-input
          name="notes"
          [label]="'GLOBAL:NOTES' | ycI18n: 'Notes'"
          (onChange)="paymentChanged()">
        </yc-input>
      </div>

      <!-- Tags -->
      <div>
        <gc-system-tags-input
          [availableTags]="availableTags"
          [tagType]="tagType"
          [formGroup]="tagsFormGroup"
          [isOptional]="true"
          (onChange)="paymentChanged()"
          (onAddNewTagToggle)="addingNewTag = $event">
        </gc-system-tags-input>
      </div>
    </ng-container>
  </div>
</ng-template>
